import { css } from 'lit';

export default css`
  :host {
    --_heading-indent: 0.5rem;

    align-items: center;
    display: flex;
    font: var(--sl-text-body-md-normal);
    inline-size: 100%;
  }

  :host([expanded]) sl-icon {
    rotate: 90deg;
  }

  :host([selectable]) {
    --_heading-indent: 1.5rem;
  }

  sl-button {
    margin-inline-start: 0.25rem;
  }

  sl-icon {
    transition: rotate 0.2s ease-in-out;
  }

  sl-checkbox {
    align-self: center;
    padding: calc((32px - var(--sl-size-input-option-sm, 0px)) / 2);
  }

  [part='wrapper'] {
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    margin-inline-start: var(--_heading-indent);
  }
`;
